/**
 * Kopiowanie kodu rabatowego jednym klikiem (linijka pod cena na karcie produktu).
 *
 * Element sam podaje kod w `data-code`, wiec nie trzeba go szukac w tresci -
 * napis moze byc przetlumaczony albo owiniety.
 */
if (!customElements.get("promo-copy")) {
  class PromoCopy extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;

      const button = this.querySelector("button");
      if (!button) return;

      this._bound = true;
      button.addEventListener("click", (event) => {
        event.preventDefault();
        this.copy();
      });
    }

    disconnectedCallback() {
      if (this._timer) clearTimeout(this._timer);
    }

    async copy() {
      const code = this.dataset.code;
      if (!code) return;

      let done = false;

      /* Clipboard API dziala tylko po https i po gescie uzytkownika - klik go
         spelnia, ale starsze przegladarki i podglad motywu w ramce potrafia go
         nie miec, stad awaryjne pole tekstowe. */
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          done = true;
        }
      } catch (e) {
        done = false;
      }

      if (!done) done = this.copyFallback(code);

      if (done) this.flash();
    }

    copyFallback(code) {
      const field = document.createElement("textarea");
      field.value = code;
      field.setAttribute("readonly", "");
      field.style.position = "fixed";
      field.style.top = "-1000px";
      document.body.appendChild(field);
      field.select();

      let ok = false;
      try {
        ok = document.execCommand("copy");
      } catch (e) {
        ok = false;
      }

      document.body.removeChild(field);
      return ok;
    }

    /* Potwierdzenie na dwie sekundy: ikona zmienia sie w znaczek, a czytnik
       ekranu dostaje komunikat przez aria-live. */
    flash() {
      this.classList.add("is-copied");

      const status = this.querySelector("[data-promo-copy-status]");
      if (status) status.textContent = "Skopiowano";

      if (this._timer) clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        this.classList.remove("is-copied");
        if (status) status.textContent = "";
      }, 2000);
    }
  }

  customElements.define("promo-copy", PromoCopy);
}
